export default __webpack_public_path__ + "static/media/cp_geo_mk.9432e7d9.svg";